export const common = {
  // App Name
  appName: "الحاسبة المالية",
  
  // Navigation
  home: "الرئيسية",
  income: "الدخل",
  expenses: "المصروفات",
  budget: "الميزانية",
  goals: "الأهداف",
  reports: "التقارير",
  notifications: "الإشعارات",
  calendar: "التقويم",
  profile: "الملف الشخصي",
  
  // Auth
  login: "تسجيل الدخول",
  register: "إنشاء حساب",
  phone: "رقم الجوال",
  otpCode: "رمز التحقق",
  fullName: "الاسم الكامل",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  forgotPassword: "نسيت كلمة المرور؟",
  
  // Dashboard
  monthlyIncome: "الدخل الشهري",
  monthlyExpenses: "المصروف الشهري",
  remaining: "المتبقي",
  currentSavings: "الادخار الحالي",
  financialAlert: "تنبيه مالي",
  
  // Income
  addNewIncome: "إضافة دخل جديد",
  salary: "راتب",
  additionalIncome: "دخل إضافي",
  projects: "مشاريع",
  
  // Expenses
  addNewExpense: "إضافة التزام جديد",
  rent: "إيجار",
  carPayment: "قسط سيارة",
  bills: "فواتير",
  subscriptions: "اشتراكات",
  
  // Budget
  needs: "احتياجات",
  wants: "رغبات",
  savings: "ادخار",
  
  // Goals
  buyCar: "شراء سيارة",
  travel: "السفر",
  homeRenovation: "تجديد المنزل",
  
  // Common
  amount: "المبلغ",
  date: "التاريخ",
  category: "الفئة",
  description: "الوصف",
  save: "حفظ",
  cancel: "إلغاء",
  edit: "تعديل",
  delete: "حذف",
  add: "إضافة",
  sar: "ريال"
};

export default common;